import React, { useEffect } from "react";
import { useParams } from "react-router";
import NewNewProductPage from "./product/NewNewProductPage";

const CONFIG = {
  lt: {
    title: "Sužinok daugiau",
    description:
      "Mokykis per realaus gyvenimo situacijas, pasitelkdamas gimtakalbių žinias.",
  },
  hu: {
    title: "Tudj meg többet",
    description:
      "Tanulj valós élethelyzeteken keresztül, anyanyelvi beszélők tudására támaszkodva.",
  },
};

const ProductPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName("description")[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return <NewNewProductPage data={data.product_page} />;
};

export default ProductPage;
